<template>
    <!-- Фільтр для історії по акаунту -->
    <div class="mb-4 border-top mt-3 pt-3" >
        <label
            for="type-select"
            class="form-label fs-15 text-success text-uppercase fw-semibold mb-3"
            >{{ $t('type') }}</label
        >
        <br />
        <div class="row g-2 list_filtr" >
            <div class="col-lg-6">
                <div class="form-check mb-2" >
                    <input class="form-check-input" type="radio" @change="change()" name="radioStatus" id="all_type" v-model="type" :value="''">
                    <label class="form-check-label" for="all_type">{{ $t('all') }}</label>
                </div>
            </div>
            <template v-for="(value, index) in opt" :key="index" >
                <div class="col-lg-6">
                    <div class="form-check mb-2" >
                        <input class="form-check-input" type="radio" @change="change()" name="radioStatus" :id="'type'+index" v-model="type" :value="value.value">
                        <label class="form-check-label" :for="'type'+index">{{ value.name }}</label>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            type: "",
            opt: [
                {
                    name: this.$t('applications'), // заявки
                    value: "request",
                },
                {
                    name: this.$t('tasks'), // таски
                    value: "task",
                },
                {
                    name: this.$t('tickets'), // тікети
                    value: "ticket",
                },
                {
                    name: this.$t('presentations'), // презентації
                    value: "presentation",
                },
                {
                    name: this.$t('monitoringLabel'), // моніторинг
                    value: "monitoring",
                }
            ]
        }
    },
    methods: {
        change(){
            this.$emit('change', 'type', this.type)
        },
    },
}
</script>